export default "__VITE_ASSET__DZxv9whd__"